import { actionGenerator, IReduxAction } from '../../utils/actions';

export const LOAD_TOP_BETS_START = 'TOP_BETS :: LOAD_TOP_BETS_START';

export type TLoadTopBetsStartAction = IReduxAction<typeof LOAD_TOP_BETS_START>;

export const loadTopBetsStart = actionGenerator<typeof LOAD_TOP_BETS_START>(LOAD_TOP_BETS_START);
